var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "prd-slid-content"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "prd-img d-flex justify-center justify-lg-end",
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('router-link', {
    staticClass: "prd-main-img",
    attrs: {
      "to": _vm.link
    }
  }, [_c('img', {
    staticClass: "d-block",
    attrs: {
      "src": _vm.mainImage,
      "alt": ""
    }
  }), _c('div', {
    staticClass: "plus-wrap"
  }, [_c('span', {
    staticClass: "plus plus--white plus--lg"
  })])]), _c('div', {
    staticClass: "d-flex flex-column justify-center py-2 py-lg-4 h-100"
  }, [_vm.slideImage1 ? _c('div', {
    staticClass: "py-2 py-lg-6 h-20"
  }, [_c('img', {
    staticClass: "d-block h-100",
    attrs: {
      "src": _vm.slideImage1,
      "alt": ""
    }
  })]) : _vm._e(), _vm.slideImage2 ? _c('div', {
    staticClass: "py-2 py-lg-6 h-20"
  }, [_c('img', {
    staticClass: "d-block h-100",
    attrs: {
      "src": _vm.slideImage2,
      "alt": ""
    }
  })]) : _vm._e(), _vm.slideImage3 ? _c('div', {
    staticClass: "py-2 py-lg-6 h-20"
  }, [_c('img', {
    staticClass: "d-block h-100",
    attrs: {
      "src": _vm.slideImage3,
      "alt": ""
    }
  })]) : _vm._e(), _vm.slideImage4 ? _c('div', {
    staticClass: "py-2 py-lg-6 h-20"
  }, [_c('img', {
    staticClass: "d-block h-100",
    attrs: {
      "src": _vm.slideImage4,
      "alt": ""
    }
  })]) : _vm._e(), _vm.slideImage5 ? _c('div', {
    staticClass: "py-2 py-lg-6 h-20"
  }, [_c('img', {
    staticClass: "d-block h-100",
    attrs: {
      "src": _vm.slideImage5,
      "alt": ""
    }
  })]) : _vm._e()])], 1)], 1), _c('div', {
    staticClass: "prd-txt-box-wrap"
  }, [_c('div', {
    staticClass: "prd-txt-box color-white"
  }, [_c('h5', [_vm._v(" " + _vm._s(_vm.tit) + " ")]), _c('p', [_vm._t("default")], 2)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }